import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

const paged = (filters) => ({ items: [], total: 0, page: 1, pageSize: 25, filters });

/* State shape same as initial state
*/
const initialState = {
  summary: null,
  reports: null,
  reportDays: 30,
  members: paged({ search: "", status: "all", planId: 0 }),
  member: null,
  subscriptions: paged({ search: "", status: "live", planId: 0 }),
  payments: { ...paged({ search: "", from: "", to: "", planId: 0, currency: "" }), totals: [] },
  comments: { ...paged({ search: "", filter: "all" }), unanswered: 0 },
  series: null,
  weeklyPlans: null,
  classes: null,
  collections: null,
  plans: null,
  newsletter: null,
  payFastLog: null,
};

const setBranch = (state, action) => (
  updateObject(state, {
    [action.key]: action.value,
  })
);

const setFilters = (state, action) => (
  updateObject(state, {
    [action.key]: updateObject(state[action.key], {
      filters: updateObject(state[action.key].filters, action.filters),
    }),
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_BRANCH]: setBranch,
  [actionType.SET_FILTERS]: setFilters,
});

export default reducer;

// SELECTORS
export const getSummary = (state) => state.summary;
export const getReports = (state) => state.reports;
export const getReportDays = (state) => state.reportDays;
export const getMembers = (state) => state.members;
export const getMember = (state) => state.member;
export const getSubscriptions = (state) => state.subscriptions;
export const getPayments = (state) => state.payments;
export const getClasses = (state) => state.classes;
export const getCollections = (state) => state.collections;
export const getPlans = (state) => state.plans;
export const getNewsletter = (state) => state.newsletter;
export const getPayFastLog = (state) => state.payFastLog;
export const getComments = (state) => state.comments;
export const getSeries = (state) => state.series;
export const getWeeklyPlans = (state) => state.weeklyPlans;
